import React from 'react';

interface JungleLayoutProps {
  children: React.ReactNode;
  headerSlot?: React.ReactNode;
}

const JungleLayout = ({ children, headerSlot }: JungleLayoutProps): JSX.Element => {

  return (
    <div className={'relative flex flex-col justify-between w-full min-h-screen bg-jungle bg-fixed bg-cover bg-no-repeat'}>
      <div className={'container max-w-2xl'}>
        {headerSlot}
        <div className={'bg-white rounded-default shadow container space-y-4 pb-10'}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default JungleLayout;
